export default {
    data() {
        return {
            // 增加一个可配置的项名称，方便不同页面复用
            routeQuery:{},
            unitName: '条数据',
            table: {
                loading: false, // 初始设为 false，由 watch 统一接管
                pagination: {
                    current: 1,
                    pageSize: 15, // 保持统一
                    total: 0,
                    showTotal: (total, range) => {
                        return `当前 ${range[0]}-${range[1]}，共 ${total} ${this.unitName}`;
                    },
                },
                data: []
            },

        }
    },
    watch: {
        '$route.query': {
            handler(newVal) {
                // 1. 解除引用，避免直接修改 $route 对象
                this.routeQuery = { ...newVal };

                // 2. 同步 URL 中的 page 到分页器 UI
                if (this.routeQuery.page) {
                    this.table.pagination.current = Number(this.routeQuery.page);
                }

                // 3. 触发请求
                this.getList();
            },
            immediate: true
        }
    },
    methods: {

        getFirstList() {
            this.updateRouteParams({ ...this.routeQuery, page: 1 });
        },

        tableChanged(pagination) {
            this.updateRouteParams({ ...this.routeQuery, page: pagination.current });
        },

        // 统一处理路由更新，避免 NavigationDuplicated 报错
        updateRouteParams(newQuery) {
            const isSame = JSON.stringify(this.$route.query) === JSON.stringify(newQuery);
            if (!isSame) {
                // 假设你的 this.$updateQuery 是对 $router.push/replace 的封装
                // 如果没有封装，直接用 this.$router.push({ query: newQuery }).catch(()=>{})
                this.$updateQuery(newQuery);
            }
        },

        // --- 数据获取方法，只负责拿数据和渲染 ---

        async getList() {

            this.table.loading = true;

            try {

                let { code, data, msg } = await this.fetchTableData(this.routeQuery);

                if (code === 0) {

                    this.table.data = data.data;
                    this.table.pagination.current = Number(data.current_page);
                    this.table.pagination.total = Number(data.total);
                    this.table.pagination.pageSize = Number(data.per_page);

                } else {
                    this.$message.error(msg || '获取数据失败');
                }
            } catch (error) {

                console.error('列表获取异常:', error);
                this.$message.error('网络或服务器异常，请稍后重试');

            } finally {

                // 无论成功失败，确保解除 loading 状态
                this.table.loading = false;

            }
        },

        // eslint-disable-next-line no-unused-vars
        async fetchTableData(query) {

            console.warn('请在组件中重写 fetchTableData 方法');

            return { code: -1, msg: '未实现 fetchTableData' };
        },

    }
}